import React, { createContext, useContext } from "react";
import { useCookieConsent, CookiePreferences } from "@/hooks/useCookieConsent";

interface CookieConsentContextValue {
  preferences: CookiePreferences | null;
  hasConsented: boolean;
  showBanner: boolean;
  showSettings: boolean;
  acceptAll: () => void;
  acceptNecessary: () => void;
  savePreferences: (stats: boolean, marketing: boolean) => void;
  openSettings: () => void;
  closeSettings: () => void;
}

const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);

export const CookieConsentProvider = ({ children }: { children: React.ReactNode }) => {
  const consent = useCookieConsent();
  return (
    <CookieConsentContext.Provider value={consent}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsentContext = () => {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) throw new Error("useCookieConsentContext must be used within CookieConsentProvider");
  return ctx;
};
